import axios from "./axiosService";
import services from "./base";
import { DateTimeFormat } from "./common";

const noteService = {
  getAllNotes: async () => {
    const response = await axios.get(services.urlNote);
    return response.data;
  },

  getNotebyExpedienteId: async (id) => {
    const response = await axios.get(services.urlNote + "/" + id, { params: { id } });
        return response.data.map((item) => ({
          ...item,
          fecha_creacion: DateTimeFormat(item.fecha_creacion),
        }));    
  },

  createNote: async (obj) => {
    try {
      const response = await axios.post(services.urlNote, { obj });
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.status;
      }

    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  deleteNoteById: async (id) => {
    try{
    const response = await axios.delete(services.urlNote + "/" + id, { params: { id } });
      if (response.status === 200) {
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: "No se pudo eliminar el registro" };
      }
    } catch (error) {
      const status = error.response?.status || 500;
      const message = error.response?.data?.error || "Error desconocido";
      return { success: false, message: `Error (${status}): ${message}` };
    }
  },
};

export default noteService;
